export default __webpack_public_path__ + "static/media/portfolio_2.e5acb9a1.png";